import { buildConfig } from "./config.js"
import { kreditDefaults } from "./defaults.js"
import { resolveZinsbindungsphasenForAxis, updateChartDekorationen } from "./dekorationen.js"
import { updateDataGrouping, updateXAxisMinMax } from "./zeitachse.js"
import { seriesLiqui } from "./series.js"
import { ChartConstants } from "../shared/constants.js"

export function createKreditChart() {
	const obj = {
		data: {
			endschulden: [],
			sondertilgungspotentiale: [],
			sondertilgungsbetraege: [],
			tilgungen: [],
			zinsen: [],
			vfeen: [],
			tilgungssurrogatBruttowerte: [],
			zinsbindungsphasen: [],
			charteinstellungen: { hidden_series: [], zeitachsen_variante: "laufzeit" },
			bewertungsdatum: 0,
			kreditstart: 0,
			startdatum: 0,
			enddatum: 0,
			kreditId: "",
			anzeigeformat: "jahr",
		},

		onZoomIn: () => {},
		onZoomReset: () => {},
		onRender: () => {},
		onLegendToggle: () => {},
		onSondertilgungspotentialClick: () => {},

		setZoomCallbacks({ onZoomIn, onZoomReset }) {
			if (typeof onZoomIn === "function") this.onZoomIn = onZoomIn
			if (typeof onZoomReset === "function") this.onZoomReset = onZoomReset
		},

		setRenderCallback(onRender) {
			if (typeof onRender === "function") this.onRender = onRender
		},

		setChartSettingsCallbacks({ onLegendToggle }) {
			if (typeof onLegendToggle === "function") this.onLegendToggle = onLegendToggle
		},

		setInteractionCallbacks({ onSondertilgungspotentialClick }) {
			if (typeof onSondertilgungspotentialClick === "function") {
				this.onSondertilgungspotentialClick = onSondertilgungspotentialClick
			}
		},

		showLoading() {
			if (this.chart) this.chart.showLoading()
		},

		hideLoading() {
			if (this.chart) this.chart.hideLoading()
		},

		resetZoom() {
			if (!this.chart) return

			this.data.anzeigeformat = "jahr"
			this.chart.zoomOut()
		},

		init() {
			const options = Highcharts.merge(kreditDefaults(), buildConfig(this))
			this.chart = new Highcharts.stockChart("chart_kredit", options)

			updateDataGrouping(this.chart, this.data.startdatum, this.data.enddatum)
			updateChartDekorationen(this)
		},

		update() {
			if (!this.chart) return

			this.chart.showLoading()

			seriesLiqui(this.data).forEach((serie) => {
				const currentSeries = this.chart.get(serie.id)
				if (!currentSeries) return

				currentSeries.update({ dataGrouping: serie.dataGrouping || {} }, false)
				currentSeries.setData(serie.data, false)
				if (currentSeries.visible !== serie.visible) currentSeries.setVisible(serie.visible, false)
			})

			updateXAxisMinMax(this)
			updateChartDekorationen(this)

			this.chart.redraw({ duration: ChartConstants.animationDuration })
			this.chart.hideLoading()
		},

		toggleHiddenSeriesLocal(seriesId, willBeVisible) {
			const id = String(seriesId)
			const settings = (this.data.charteinstellungen ||= {})
			const hiddenSeries = Array.isArray(settings.hidden_series) ? settings.hidden_series.map(String) : []

			settings.hidden_series = hiddenSeries

			if (willBeVisible) {
				settings.hidden_series = settings.hidden_series.filter((entry) => entry !== id)
			} else if (!settings.hidden_series.includes(id)) {
				settings.hidden_series.push(id)
			}
		},

		visiblePhasenlabels() {
			if (!this.chart) return []

			const xAxis = this.chart.xAxis[0]
			const extremes = xAxis.getExtremes()
			const plotLeft = this.chart.plotLeft
			const plotRight = this.chart.plotLeft + this.chart.plotWidth

			return resolveZinsbindungsphasenForAxis(this).flatMap((phase) => {
				if (!phase?.label || phase?.from == null || phase?.to == null) return []

				const visibleFrom = Math.max(phase.from, extremes.min)
				const visibleTo = Math.min(phase.to, extremes.max)
				if (visibleTo <= visibleFrom) return []

				return [{
					label: phase.label,
					left: plotLeft + xAxis.toPixels(visibleFrom, true) + 4,
					minLeft: plotLeft + 4,
					maxRight: plotRight - 4,
				}]
			})
		},
	}

	return obj
}
